/*
 * @Author: Code-HHX
 * @Date: 2021-12-10 11:15:50
 * @LastEditors: Code-HHX
 * @LastEditTime: 2021-12-31 11:00:43
 * @Description:
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as utils from "./util/utils";
import Meta from 'vue-meta'
// import "amfe-flexible";
import Waves from "vue-waves-effect";
import "vue-waves-effect/dist/vueWavesEffect.css";
// import echarts from "./config/echarts-load";
import VueClipboard from "vue-clipboard2";

import {
  Swipe,
  SwipeItem,
  Lazyload,
  Col,
  Row,
  Popup,
  Toast,
  Image,
  Dialog,
  Field,
  Button,
  Form,
  Loading,
  Card,
  DropdownMenu,
  DropdownItem,
  Popover,
  RadioGroup,
  Radio, Tag, Uploader, Icon, PullRefresh, List, PasswordInput, NumberKeyboard, Skeleton, Calendar
} from 'vant'

Vue.config.productionTip = false
//语言包

import "tailwindcss/tailwind.css"
import "@/assets/css/poppins.css"
// import "@/theme/var.less"
//全局注册组件
import FixedTop from "@/components/FixedTop";
import i18n from "./i18n";
// const navLang = 'zh' //process.env.VUEAPP_CUSTOMER === 'jzz' ? "zh": 'en' //navigator.language || navigator.userLanguage || "en-US";
// console.log(navLang);
// let localLang = navLang || false;
// let lang = "zh" || "enUS";
//
// if (localLang == "zh-CN") {
// 	localLang = "en-US";
// 	lang = "en-US";
// 	//localLang = "th-TH";
// 	//lang = "th-TH";
// }
// localStorage.setItem("lang", "zh-CN");



Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)
Vue.use(Col)
Vue.use(Row)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(Meta)
Vue.use(Image)
Vue.use(Waves);
Vue.use(Dialog);
Vue.use(VueClipboard);
Vue.use(Field);
Vue.use(Button);
Vue.use(Form)
Vue.use(Loading)
Vue.use(Card)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Popover)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Tag)
Vue.use(Uploader)
Vue.use(Icon)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(Skeleton)
Vue.use(Calendar)

Vue.component("FixedTop", FixedTop);


//全局暴露api接口
Vue.prototype.$utils = utils;
// Vue.prototype.$echarts = echarts;



new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
